import { Component, ErrorHandler, OnInit,ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { UserService } from '../../shared/user.service';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'app-against-notification-form4',
  templateUrl: './against-notification-form4.component.html',
  styleUrls: ['./against-notification-form4.component.css']
})
export class AgainstNotificationForm4Component implements OnInit {
  existingFiles = {
  APP_Caste_Certificate:       '',
  APP_PA_AdharCard:            '',
  APP_PA_PanCard:              '',
  APP_Resident_certificate:    '',
  Affidavit:                   '',
  APP_POD_Certificate:         '',
  APP_Income_Certificate:      '',
  APP_Affidavit_Certificate:   '',
  bank_passbook:               '',
  APP_Exserviceman_Certificate:'',
  APP_Disability_Certificate:  '',
  VoterCard:                   '',
  APP_Secondary_Affidavit:     ''
};

isDocumentsLoaded: boolean = false;

  fileToUpload: File = null;
  app: any = {};
  r: any = {};  
  App_Reg_No: any;
   formInvalid = false;
  APP_Reg_No: any;
  //isDocumentsLoaded = false;
  documentsFormvalid: boolean;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
  }

  ngOnInit() {
this.route.queryParams.subscribe(params => {
    this.App_Reg_No = params['App_Reg_No'];
      if (!this.App_Reg_No || !sessionStorage.getItem('step3Completed')) {
      this.router.navigate(['/applicant-register']);
      return;
    }
    sessionStorage.removeItem('step3Completed');  // ← consume

    this.app.APP_IsJoint = params['IsJoint'];
      this.app.Ex_Servicemen = params['Ex_Servicemen'];
        this.app.Disability = params['Disability'];
        this.app.CA_Id_Fk = params['CA_Id_Fk'];
        console.log(this.app.CA_Id_Fk);
        // console.log(this.app.Disability);
    console.log('Received App No:', this.App_Reg_No);

    // assign to your model
    this.app.App_Reg_No = this.App_Reg_No;
this.GetByIdVerifydocumentdetails();
  });
  }




// SaveStep4(form: NgForm) {

//   if (form.invalid) {
//     this.formInvalid = true;
//     return;
//   }

//   this.formInvalid = false;

//   // Must send Registration Number
//   this.app.APP_Reg_No = this.r.App_Reg_No;   // from step 2 response

//   this.userService.Step4_UpdateDocuments(this.app)
//     .subscribe({
//       next: (res: any) => {
//         alert('Documents Saved Successfully');
//         // this.router.navigate(['/against-notification-form5']);

             
// this.router.navigate(
//   ['/against-notification-form5'],
//   { 
//     queryParams: { 
//       APP_Not_Id_Fk: res.APP_Not_Id_Fk,
//       APP_Project_id_fk: res.APP_Project_id_fk,
//       APP_CA_Id_FK: res.APP_CA_Id_FK,
//       App_Reg_No: res.App_Reg_No,
//       Applicant_Name: res.Applicant_Name,
//       Email_Address: res.Email_Address,
//       Mobile_No: res.Mobile_No,
//       Village_Mohalla: res.Village_Mohalla,
//       Post_Office:res.Post_Office,
//       Pincode: res.Pincode,
//       DI_District: res.DI_District,
//       APP_AnnualIncome: res.APP_AnnualIncome

//     } 
//   }
// );
//       },
//       error: (err) => {
//         console.error(err);
//         alert('Something went wrong');
//       }
//     });
// }

SaveStep4(form: NgForm) {
debugger;
  if (form.invalid) {
    this.formInvalid = true;
    return;
  }

  this.formInvalid = false;

  // ✅ Build payload with new files OR existing URLs
  const payload = {
    APP_Reg_No: this.App_Reg_No,  // ✅ Fixed: use component variable not this.r

    APP_PA_AdharCard:             this.app.APP_PA_AdharCard             || this.existingFiles.APP_PA_AdharCard,
    APP_PA_PanCard:               this.app.APP_PA_PanCard               || this.existingFiles.APP_PA_PanCard,
    APP_Caste_Certificate:        this.app.APP_Caste_Certificate        || this.existingFiles.APP_Caste_Certificate,
    APP_Resident_certificate:     this.app.APP_Resident_certificate     || this.existingFiles.APP_Resident_certificate,
    Affidavit:                    this.app.Affidavit                    || this.existingFiles.Affidavit,
    APP_POD_Certificate:          this.app.APP_POD_Certificate          || this.existingFiles.APP_POD_Certificate,
    APP_Income_Certificate:       this.app.APP_Income_Certificate       || this.existingFiles.APP_Income_Certificate,
    APP_Affidavit_Certificate:    this.app.APP_Affidavit_Certificate    || this.existingFiles.APP_Affidavit_Certificate,
    bank_passbook:                this.app.bank_passbook                || this.existingFiles.bank_passbook,
    APP_Exserviceman_Certificate: this.app.APP_Exserviceman_Certificate || this.existingFiles.APP_Exserviceman_Certificate,
    APP_Disability_Certificate:   this.app.APP_Disability_Certificate   || this.existingFiles.APP_Disability_Certificate,
    VoterCard:                    this.app.VoterCard                    || this.existingFiles.VoterCard,
    APP_Secondary_Affidavit:      this.app.APP_Secondary_Affidavit      || this.existingFiles.APP_Secondary_Affidavit,
  };

  this.userService.Step4_UpdateDocuments(payload)
    .subscribe({
      next: (res: any) => {
        // alert('Documents Saved Successfully');
 swal('Success!', 'Documents are Saved Successfully, Please continue with Step5', 'success');
 sessionStorage.setItem('step4Completed', '1');
        this.router.navigate(
          ['/against-notification-form5'],
          {
            queryParams: {
              APP_Not_Id_Fk:     res.APP_Not_Id_Fk,
              APP_Project_id_fk: res.APP_Project_id_fk,
              APP_CA_Id_FK:      res.APP_CA_Id_FK,
              App_Reg_No:        res.App_Reg_No,       // ✅ Fixed: res.APP_Reg_No
              Applicant_Name:    res.Applicant_Name,
              Email_Address:     res.Email_Address,
              Mobile_No:         res.Mobile_No,
              Village_Mohalla:   res.Village_Mohalla,
              Post_Office:       res.Post_Office,
              Pincode:           res.Pincode,
              DI_District:       res.DI_District,
              APP_AnnualIncome:  res.APP_AnnualIncome,
            }
          }
        );
      },
      error: (err) => {
        console.error(err);
        alert('Something went wrong');
      }
    });
}


















// GetByIdVerifydocumentdetails() {

//   if (!this.App_Reg_No) {
//     console.error('App_Reg_No is missing');
//     return;
//   }

//   document.getElementById('loader-spinner').style.display = "block";

//   this.userService.GetByIdverificationdocuments(this.App_Reg_No)
//     .subscribe(
//       (response: any) => {

//         console.log("Full API Response:", response);

//         if (response && response.data) {

//           this.r = response.data;   // ✅ FIXED

//           this.app.APP_Caste_Certificate = this.r.APP_Caste_Certificate;
//           this.app.APP_PA_AdharCard = this.r.APP_PA_AdharCard;
//           this.app.APP_PA_PanCard = this.r.APP_PA_PanCard;
//           this.app.APP_Resident_certificate = this.r.APP_Resident_certificate;
//           this.app.Affidavit = this.r.Affidavit;
//           this.app.APP_POD_Certificate = this.r.APP_POD_Certificate;
//           this.app.APP_Income_Certificate = this.r.APP_Income_Certificate;
//           this.app.APP_Affidavit_Certificate = this.r.APP_Affidavit_Certificate;
//           this.app.bank_passbook = this.r.bank_passbook;
//           this.app.APP_Exserviceman_Certificate = this.r.APP_Exserviceman_Certificate;
//           this.app.APP_Disability_Certificate = this.r.APP_Disability_Certificate;
//           this.app.VoterCard = this.r.VoterCard;
//           this.app.APP_Secondary_Affidavit = this.r.APP_Secondary_Affidavit;

//         }

//         document.getElementById('loader-spinner').style.display = "none";
//       },
//       (error) => {
//         console.error(error);
//         document.getElementById('loader-spinner').style.display = "none";
//       }
//     );
// }


//old
// GetByIdVerifydocumentdetails() {

//   if (!this.App_Reg_No) {
//     console.error('App_Reg_No is missing');
//     return;
//   }

//   document.getElementById('loader-spinner').style.display = "block";

//   this.userService.GetByIdverificationdocuments(this.App_Reg_No)
//     .subscribe(
//       (response: any) => {

//         console.log("Full API Response:", response);

//         if (response && response.data) {

//           this.r = response.data;

//           this.app.APP_Caste_Certificate = this.r.APP_Caste_Certificate;
//           this.app.APP_PA_AdharCard = this.r.APP_PA_AdharCard;
//           this.app.APP_PA_PanCard = this.r.APP_PA_PanCard;
//           this.app.APP_Resident_certificate = this.r.APP_Resident_certificate;
//           this.app.Affidavit = this.r.Affidavit;
//           this.app.APP_POD_Certificate = this.r.APP_POD_Certificate;
//           this.app.APP_Income_Certificate = this.r.APP_Income_Certificate;
//           this.app.APP_Affidavit_Certificate = this.r.APP_Affidavit_Certificate;
//           this.app.bank_passbook = this.r.bank_passbook;
//           this.app.APP_Exserviceman_Certificate = this.r.APP_Exserviceman_Certificate;
//           this.app.APP_Disability_Certificate = this.r.APP_Disability_Certificate;
//           this.app.VoterCard = this.r.VoterCard;
//           this.app.APP_Secondary_Affidavit = this.r.APP_Secondary_Affidavit;

//           // ✅ ADD THIS PART
//           if (
//             this.checkValid(this.app.APP_Resident_certificate) &&
//             this.checkValid(this.app.APP_POD_Certificate) &&
//             this.checkValid(this.app.APP_Income_Certificate) &&
//             this.checkValid(this.app.APP_Affidavit_Certificate) &&
//             this.checkValid(this.app.bank_passbook) &&
//             this.checkValid(this.app.VoterCard)
//           ) {
//             this.isDocumentsLoaded = true;
//             // this.documentsFormvalid = true;
//           }

//         }

//         document.getElementById('loader-spinner').style.display = "none";
//       },
//       (error) => {
//         console.error(error);
//         document.getElementById('loader-spinner').style.display = "none";
//       }
//     );
// }
// checkValid(value: any): boolean {
//   return value &&
//          value !== 'NA.pdf' &&
//          value !== 'null' &&
//          value !== null &&
//          value !== '';
// }



GetByIdVerifydocumentdetails() {
  if (!this.App_Reg_No) {
    console.error('App_Reg_No is missing');
    return;
  }

  document.getElementById('loader-spinner').style.display = "block";

  this.userService.GetByIdverificationdocuments(this.App_Reg_No)
    .subscribe(
      (response: any) => {
        console.log("Full API Response:", response);

        if (response && response.data) {
          this.r = response.data;

          // ✅ Store URLs in existingFiles only — never patch into form file inputs
          this.existingFiles.APP_Caste_Certificate        = this.r.APP_Caste_Certificate;
          this.existingFiles.APP_PA_AdharCard             = this.r.APP_PA_AdharCard;
          this.existingFiles.APP_PA_PanCard               = this.r.APP_PA_PanCard;
          this.existingFiles.APP_Resident_certificate     = this.r.APP_Resident_certificate;
          this.existingFiles.Affidavit                    = this.r.Affidavit;
          this.existingFiles.APP_POD_Certificate          = this.r.APP_POD_Certificate;
          this.existingFiles.APP_Income_Certificate       = this.r.APP_Income_Certificate;
          this.existingFiles.APP_Affidavit_Certificate    = this.r.APP_Affidavit_Certificate;
          this.existingFiles.bank_passbook                = this.r.bank_passbook;
          this.existingFiles.APP_Exserviceman_Certificate = this.r.APP_Exserviceman_Certificate;
          this.existingFiles.APP_Disability_Certificate   = this.r.APP_Disability_Certificate;
          this.existingFiles.VoterCard                    = this.r.VoterCard;
          this.existingFiles.APP_Secondary_Affidavit      = this.r.APP_Secondary_Affidavit;

          // ✅ Keep this.app file fields empty — file inputs cannot have URLs
          this.app.APP_Caste_Certificate        = '';
          this.app.APP_PA_AdharCard             = '';
          this.app.APP_PA_PanCard               = '';
          this.app.APP_Resident_certificate     = '';
          this.app.Affidavit                    = '';
          this.app.APP_POD_Certificate          = '';
          this.app.APP_Income_Certificate       = '';
          this.app.APP_Affidavit_Certificate    = '';
          this.app.bank_passbook                = '';
          this.app.APP_Exserviceman_Certificate = '';
          this.app.APP_Disability_Certificate   = '';
          this.app.VoterCard                    = '';
          this.app.APP_Secondary_Affidavit      = '';

          // ✅ Check if documents already uploaded (use existingFiles)
          // if (
          //   this.checkValid(this.existingFiles.APP_Resident_certificate) &&
          //   this.checkValid(this.existingFiles.APP_POD_Certificate) &&
          //   this.checkValid(this.existingFiles.APP_Income_Certificate) &&
          //   this.checkValid(this.existingFiles.APP_Affidavit_Certificate) &&
          //   this.checkValid(this.existingFiles.bank_passbook) &&
          //   this.checkValid(this.existingFiles.VoterCard)
          // ) {
          //   this.isDocumentsLoaded = true;
          // }
          this.checkAllRequiredDocuments();
        }

        document.getElementById('loader-spinner').style.display = "none";
      },
      (error) => {
        console.error(error);
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
}

checkValid(value: any): boolean {
  return value &&
         value !== 'NA.pdf' &&
         value !== 'null' &&
         value !== null &&
         value !== '';
}










//old
  // CasteFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
  //   // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;
  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       //  this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.Caste_CertificateErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('APP_Caste_Certificate');
  //         i.value = "";
  //         if (error.status == 400) {
  //           //   this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('APP_Caste_Certificate');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }

  CasteFileInput(file: FileList) {
                      if (!file || file.length === 0) {
    this.app.APP_Caste_Certificate = "";
    this.checkAllRequiredDocuments();
    return;
  }
    
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.APP_Caste_Certificate = uploadedFilename;
          this.app.Caste_CertificateErrorMessage = "";
          this.checkAllRequiredDocuments();
        }, (error) => {
          let i: any = document.getElementById('APP_Caste_Certificate');
          i.value = "";
          this.app.APP_Caste_Certificate = ""; // ✅ Clear on error
          //this.checkAllRequiredDocuments();

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Caste_Certificate');
      i.value = "";
      this.app.APP_Caste_Certificate = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
      this.checkAllRequiredDocuments();
    }
}

  getCasteFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Caste_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  // AadharcardcertificateFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
  //   // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;

  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.APP_PA_AdharCardErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('APP_PA_AdharCard');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('APP_PA_AdharCard');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }

   AadharcardcertificateFileInput(file: FileList) {
                  if (!file || file.length === 0) {
    this.app.APP_PA_AdharCard = "";
    this.checkAllRequiredDocuments();
    return;
  }
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.APP_PA_AdharCard = uploadedFilename;
          this.app.APP_PA_AdharCardErrorMessage = "";
          this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('APP_PA_AdharCard');
          i.value = "";
          this.app.APP_PA_AdharCard = ""; // ✅ Clear on error

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
            this.checkAllRequiredDocuments();
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_PA_AdharCard');
      i.value = "";
      this.app.APP_PA_AdharCard = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
      this.checkAllRequiredDocuments();
    }
}







  getAadharcardcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_PA_AdharCard');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  // PANcertificateFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   // let regex = /^([a-zA-Z0-9\s_\-:\\.]+)\.(pdf|pdef)$/i;
  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
  //   //  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;

  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.APP_PA_PanCardErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('APP_PA_PanCard');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('APP_PA_PanCard');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }

PANcertificateFileInput(file: FileList) {
              if (!file || file.length === 0) {
    this.app.APP_PA_PanCard = "";
    this.checkAllRequiredDocuments();
    return;
  }
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.APP_PA_PanCard = uploadedFilename;
          this.app.APP_PA_PanCardErrorMessage = "";
          this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('APP_PA_PanCard');
          i.value = "";
          this.app.APP_PA_PanCard = ""; // ✅ Clear on error

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
            this.checkAllRequiredDocuments();
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_PA_PanCard');
      i.value = "";
      this.app.APP_PA_PanCard = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
      this.checkAllRequiredDocuments();
    }
}










  getPANcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_PA_PanCard');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

//old
  // ResidentialcertificateFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   // let regex = /^([a-zA-Z0-9\s_\-:\\.]+)\.(pdf|pdef)$/i;

  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;

  //   // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;

  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.APP_Resident_certificateErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('APP_Resident_certificate');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('APP_Resident_certificate');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }

ResidentialcertificateFileInput(file: FileList) {
            if (!file || file.length === 0) {
    this.app.APP_Resident_certificate = "";
    this.checkAllRequiredDocuments();
    return;
  }
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.APP_Resident_certificate = uploadedFilename;
          this.app.APP_Resident_certificateErrorMessage = "";
           this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('APP_Resident_certificate');
          i.value = "";
          this.app.APP_Resident_certificate = ""; // ✅ Clear on error
           this.checkAllRequiredDocuments();

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
             this.checkAllRequiredDocuments();
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Resident_certificate');
      i.value = "";
      this.app.APP_Resident_certificate = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
        this.checkAllRequiredDocuments();
    }
}













  getResidentialcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Resident_certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  // AffidavitFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   // let regex = /^([a-zA-Z0-9\s_\-:\\.]+)\.(pdf|pdef)$/i;
  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
  //   // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;
  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.AffidavitErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('Affidavit');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('Affidavit');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }


AffidavitFileInput(file: FileList) {
            if (!file || file.length === 0) {
    this.app.Affidavit = "";
    this.checkAllRequiredDocuments();
    return;
  }
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.Affidavit = uploadedFilename;
          this.app.AffidavitErrorMessage = "";
          this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('Affidavit');
          i.value = "";
          this.app.Affidavit = ""; // ✅ Clear on error

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
            this.checkAllRequiredDocuments();
          }
        });
    }
    else {
      let i: any = document.getElementById('Affidavit');
      i.value = "";
      this.app.Affidavit = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
      this.checkAllRequiredDocuments();
    }
}









  getAffidavitFileInputFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('Affidavit');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  //old
  // DepositFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
  //   // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;
  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.APP_POD_CertificateErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('APP_POD_Certificate');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('APP_POD_Certificate');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }


DepositFileInput(file: FileList) {
              if (!file || file.length === 0) {
    this.app.APP_POD_Certificate = "";
    this.checkAllRequiredDocuments();
    return;
  }
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name; // ✅ .name gives ONLY filename, no fake path

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.APP_POD_Certificate = uploadedFilename;
          this.app.APP_POD_CertificateErrorMessage = "";
          this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('APP_POD_Certificate');
          i.value = "";
          this.app.APP_POD_Certificate = ""; // ✅ Clear on error

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
            this.checkAllRequiredDocuments();
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_POD_Certificate');
      i.value = "";
      this.app.APP_POD_Certificate = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
      this.checkAllRequiredDocuments();
    }
}


  getDepositFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_POD_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  //old
  // IncomecertificateFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
  //   // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;
  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.APP_Income_CertificateErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('APP_Income_Certificate');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('APP_Income_Certificate');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }

   IncomecertificateFileInput(file: FileList) {
                 if (!file || file.length === 0) {
    this.app.APP_Income_Certificate = "";
    this.checkAllRequiredDocuments();
    return;
  }
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.APP_Income_Certificate = uploadedFilename;
          this.app.APP_Income_CertificateErrorMessage = "";
          this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('APP_Income_Certificate');
          i.value = "";
          this.app.APP_Income_Certificate = ""; // ✅ Clear on error

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
            this.checkAllRequiredDocuments();
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Income_Certificate');
      i.value = "";
      this.app.APP_Income_Certificate = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
       this.checkAllRequiredDocuments();
    }
}







  getIncomecertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Income_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
//old
  // ApplicantAffidavitcertificateFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
  //   // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;
  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.APP_Affidavit_CertificateErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('APP_Affidavit_Certificate');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('APP_Affidavit_Certificate');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }


  ApplicantAffidavitcertificateFileInput(file: FileList) {
              if (!file || file.length === 0) {
    this.app.APP_Affidavit_Certificate = "";
    this.checkAllRequiredDocuments();
    return;
  }
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.APP_Affidavit_Certificate = uploadedFilename;
          this.app.APP_Affidavit_CertificateErrorMessage = "";
          this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('APP_Affidavit_Certificate');
          i.value = "";
          this.app.APP_Affidavit_Certificate = ""; // ✅ Clear on error
          this.checkAllRequiredDocuments();

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Affidavit_Certificate');
      i.value = "";
      this.app.APP_Affidavit_Certificate = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
        this.checkAllRequiredDocuments();
    }
}

  getApplicantAffidavitcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Affidavit_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


//old
  // BankPassbookcertificateFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   // let regex = /^([a-zA-Z0-9\s_\-:\\.]+)\.(pdf|pdef)$/i;
  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
  //   // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;
  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.bank_passbookErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('bank_passbook');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('bank_passbook');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }



   BankPassbookcertificateFileInput(file: FileList) {
          if (!file || file.length === 0) {
    this.app.bank_passbook = "";
    this.checkAllRequiredDocuments();
    return;
  }
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.bank_passbook = uploadedFilename;
          this.app.bank_passbookErrorMessage = "";
          this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('bank_passbook');
          i.value = "";
          this.app.bank_passbook = ""; // ✅ Clear on error
          this.checkAllRequiredDocuments();

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
            this.checkAllRequiredDocuments();
          }
        });
    }
    else {
      let i: any = document.getElementById('bank_passbook');
      i.value = "";
      this.app.bank_passbook = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
        this.checkAllRequiredDocuments();
    }
}










  getBankPassbookcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('bank_passbook');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
//old
  // ExServicemanFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
  //   // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;
  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.APP_Exserviceman_CertificateErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('APP_Exserviceman_Certificate');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('APP_Exserviceman_Certificate');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }



  ExServicemanFileInput(file: FileList) {
         if (!file || file.length === 0) {
    this.app.APP_Exserviceman_Certificate = "";
    this.checkAllRequiredDocuments();
    return;
  }
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.APP_Exserviceman_Certificate = uploadedFilename;
          this.app.APP_Exserviceman_CertificateErrorMessage = "";
          this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('APP_Exserviceman_Certificate');
          i.value = "";
          this.app.APP_Exserviceman_Certificate = ""; // ✅ Clear on error
          this.checkAllRequiredDocuments();
          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Exserviceman_Certificate');
      i.value = "";
      this.app.APP_Exserviceman_Certificate = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
        this.checkAllRequiredDocuments();
    }
}











  getExServicemanFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Exserviceman_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  // DisabilitycertificateFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
  //   //  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;
  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.APP_Disability_CertificateErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('APP_Disability_Certificate');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('APP_Disability_Certificate');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }


   DisabilitycertificateFileInput(file: FileList) {
     if (!file || file.length === 0) {
    this.app.APP_Disability_Certificate = "";
    this.checkAllRequiredDocuments();
    return;
  }
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.APP_Disability_Certificate = uploadedFilename;
          this.app.APP_Disability_CertificateErrorMessage = "";
          this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('APP_Disability_Certificate');
          i.value = "";
          this.app.APP_Disability_Certificate = ""; // ✅ Clear on error

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
            this.checkAllRequiredDocuments();
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Disability_Certificate');
      i.value = "";
      this.app.APP_Disability_Certificate = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
        this.checkAllRequiredDocuments();
    }
}







  getDisabilitycertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('APP_Disability_Certificate');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  //old
  // VoteridcertificateFileInput(file: FileList) {

  //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
  //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
  //   //  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //   let regex = /^[^\\/]+\.pdf$/;
  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.VoterCardErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('VoterCard');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('VoterCard');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }


   VoteridcertificateFileInput(file: FileList) {
    debugger;
  //     if (!file || file.length === 0) {
  //   this.app.VoterCard = "";
  //   this.checkAllRequiredDocuments();
  //   return;
  // }
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.VoterCard = uploadedFilename;
          this.app.VoterCardErrorMessage = "";
          this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('VoterCard');
          i.value = "";
          this.app.VoterCard = ""; // ✅ Clear on error
          this.checkAllRequiredDocuments();

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
            this.checkAllRequiredDocuments();
          }
        });
    }
    else {
      let i: any = document.getElementById('VoterCard');
      i.value = "";
      this.app.VoterCard = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
      this.checkAllRequiredDocuments();
    }
}








  getVoterCardcertificateFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('VoterCard');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
        
  


    // CoApplicantAffidavitcertificateFileInput(file: FileList) {
  
    //   // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf)$/;
    //   //  let regex = /^([a-zA-Z0-9\s_\-().])+(\.(jpeg|jpg|png|pdf))$/i;
    //     // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
    //     let regex = /^[^\\/]+\.pdf$/;
    //   let s: any = file.item(0).size / 1024;
    //   let size: any = parseFloat(s).toFixed(2);
    //   let uploadedFilename = file.item(0).name;
    //   if (uploadedFilename.match(regex) && (size <= 2048)) {
    //     this.fileToUpload = file.item(0);
    //     var reader = new FileReader();
    //     reader.onload = (event: any) => {
    //       // this.UO_UploadimageUrl1 = event.target.result;
    //     }
    //     reader.readAsDataURL(this.fileToUpload);
    //     const data = new FormData();
    //     data.append("UploadedImage", file.item(0));
    //     let x = this.userService.uploadImage(data);
    //     x.subscribe(
    //       (response) => {
    //         console.log(response);
    //         this.app.APP_Secondary_AffidavitErrorMessage = "";
    //       }, (error) => {
    //         let i: any = document.getElementById('APP_Secondary_Affidavit');
    //         i.value = "";
    //         if (error.status == 400) {
    //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
    //           swal('Warning!', error.error.Message, 'warning');
    //         }
    //       });
    //   }
    //   else {
    //     let i: any = document.getElementById('APP_Secondary_Affidavit');
    //     i.value = "";
    //     if (!uploadedFilename.match(regex))
    //       swal('Warning!', "Please upload image file with extension .pdf", 'warning');
    //     else if (size > 2048)
    //       swal('Warning!', "Please upload file less than 2mb", 'warning');
    //   }
    // }
  

CoApplicantAffidavitcertificateFileInput(file: FileList) {
    let regex = /^[^/\\]+\.pdf$/i;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);

      var reader = new FileReader();
      reader.onload = (event: any) => { }
      reader.readAsDataURL(this.fileToUpload);

      const data = new FormData();
      data.append("UploadedImage", file.item(0));

      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response: any) => {
          console.log(response);

          // ✅ Save only the clean filename to your model
          this.app.APP_Secondary_Affidavit = uploadedFilename;
          this.app.APP_Secondary_AffidavitErrorMessage = "";
          this.checkAllRequiredDocuments();

        }, (error) => {
          let i: any = document.getElementById('APP_Secondary_Affidavit');
          i.value = "";
          this.app.APP_Secondary_Affidavit = ""; // ✅ Clear on error

          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
            this.checkAllRequiredDocuments();
          }
        });
    }
    else {
      let i: any = document.getElementById('APP_Secondary_Affidavit');
      i.value = "";
      this.app.APP_Secondary_Affidavit = ""; // ✅ Clear on invalid

      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension .pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2MB", 'warning');
      this.checkAllRequiredDocuments();
    }
}








    getCoApplicantAffidavitcertificateFileInput() {
      let imagename = null;
      try {
        imagename = document.getElementById('APP_Secondary_Affidavit');
        return imagename.files[0].name;
      }
      catch (e) {
        return null;
      }
    }



    checkAllRequiredDocuments(): void {
      debugger;
  const requiredExisting = [
    this.existingFiles.APP_Resident_certificate,
    this.existingFiles.APP_POD_Certificate,
    this.existingFiles.APP_Income_Certificate,
    this.existingFiles.APP_Affidavit_Certificate,
    this.existingFiles.bank_passbook,
    //this.existingFiles.VoterCard,
    this.existingFiles.APP_PA_PanCard,
    this.existingFiles.APP_PA_AdharCard
  ];

  const requiredApp = [
    this.app.APP_Resident_certificate,
    this.app.APP_POD_Certificate,
    this.app.APP_Income_Certificate,
    this.app.APP_Affidavit_Certificate,
    this.app.bank_passbook,
    this.app.APP_PA_PanCard,
    this.app.APP_PA_AdharCard
    //this.app.VoterCard,
  ];
  
  // Conditional: Caste Certificate required if CA_Id_Fk !== 18
  if (this.app.CA_Id_Fk != 18) {
    debugger;
    requiredExisting.push(this.existingFiles.APP_Caste_Certificate);
    requiredApp.push(this.app.APP_Caste_Certificate);
  }

  // Conditional: Ex-Serviceman Certificate required if Ex_Servicemen === 'Y'
  if (this.app.Ex_Servicemen === 'Y') {
    debugger;
    requiredExisting.push(this.existingFiles.APP_Exserviceman_Certificate);
    requiredApp.push(this.app.APP_Exserviceman_Certificate);
  }

  // Conditional: Disability Certificate required if Disability === 'Y'
  if (this.app.Disability === 'Y') {
    debugger;
    requiredExisting.push(this.existingFiles.APP_Disability_Certificate);
    requiredApp.push(this.app.APP_Disability_Certificate);
  }
  // A field is satisfied if EITHER existingFiles OR app (newly uploaded) has a valid value
  this.isDocumentsLoaded = requiredExisting.every((existingVal, index) =>
    this.checkValid(existingVal) || this.checkValid(requiredApp[index])
  );
}














}




// WEBPACK FOOTER //
// ./src/app/registration/against-notification-form4/against-notification-form4.component.ts